import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FacturasComponent } from "./facturas/facturas.component";
import { TablaFacturasComponent } from "./facturas/components/tabla-facturas/tabla-facturas.component";
import { RouterModule } from "@angular/router";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { DetalleFacturaComponent } from "./detalle-factura/detalle-factura.component";
import { FichaFacturaComponent } from "./detalle-factura/components/ficha-factura/ficha-factura.component";

import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatTableModule } from "@angular/material/table";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatChipsModule } from "@angular/material/chips";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatListModule } from "@angular/material/list";
import { MatTabsModule } from "@angular/material/tabs";

import { OoccModule } from "../oocc/oocc.module";
import { DialogEstadoFacturaComponent } from "./detalle-factura/components/dialog-estado-factura/dialog-estado-factura.component";
import { AuthGuard } from "@auth0/auth0-angular";
import { RoleGuardService } from "../shared/services/auth/role-guard.service";
import { SearchboxComponent } from './facturas/components/searchbox/searchbox.component';

const routes = [
    {
        path: "facturas",
        component: FacturasComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1, 3, 4],
        },
    },
    {
        path: "facturas/:idFactura",
        component: DetalleFacturaComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1, 3, 4],
        },
    },
];

@NgModule({
    declarations: [
        FacturasComponent,
        TablaFacturasComponent,
        DetalleFacturaComponent,
        FichaFacturaComponent,
        DialogEstadoFacturaComponent,
        SearchboxComponent,
    ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        FuseSharedModule,
        TranslateModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatListModule,
        OoccModule,
        MatDatepickerModule,
        MatToolbarModule,
        MatDialogModule,
        MatCheckboxModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatTableModule,
        MatListModule,
        MatButtonToggleModule,
        MatTabsModule
    ],
})
export class FacturaModule {}
